/*
  Generates a fresh, randomly-placed star layer inside every .gradient section on each page
  load — replaces the old fixed CSS radial-gradient tile (see t1-tokens.css), which repeated the
  same pattern everywhere and read as static/dated once background-attachment: fixed pinned it
  to the viewport instead of scrolling with the page.

  Star count scales with each section's own area so a small footer and a tall hero both read as
  the same density, rather than either looking empty or overcrowded.
*/
(function () {
  var MIN_STARS = 20;
  var MAX_STARS = 160;
  var AREA_PER_STAR = 4500; // px^2 — roughly one star per 67x67px patch

  function scatterStars(section) {
    var width = section.offsetWidth;
    var height = section.offsetHeight;
    if (width === 0 || height === 0) return;

    var count = Math.round((width * height) / AREA_PER_STAR);
    count = Math.max(MIN_STARS, Math.min(MAX_STARS, count));

    var layer = document.createElement('div');
    layer.className = 't1-starfield';
    layer.setAttribute('aria-hidden', 'true');

    var frag = document.createDocumentFragment();
    for (var i = 0; i < count; i++) {
      var star = document.createElement('span');
      var size = (Math.random() * 1.6 + 0.8).toFixed(2);
      star.style.top = (Math.random() * 100).toFixed(2) + '%';
      star.style.left = (Math.random() * 100).toFixed(2) + '%';
      star.style.width = size + 'px';
      star.style.height = size + 'px';
      star.style.opacity = (Math.random() * 0.6 + 0.35).toFixed(2);
      frag.appendChild(star);
    }
    layer.appendChild(frag);
    section.insertBefore(layer, section.firstChild);
  }

  function init() {
    var sections = document.querySelectorAll('.gradient');
    for (var i = 0; i < sections.length; i++) {
      scatterStars(sections[i]);
    }
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();
